import React from "react";
import { Link, NavLink } from "react-router-dom";
import logoImage from "images/logo-wce.png";
import NAVBAR_MENU from "constant/menu";

const Menu = ({ isStart }) => {
  return (
    <div className="flex items-center ">
      <div className="mr-6 md2:mr-10 w-24">
        <Link to="/">
          <img className="w-24 min-w-24" src={logoImage} alt={"WCE Logo"} />
        </Link>
      </div>
      <div className="flex gap-3 lg:gap-6">
        {NAVBAR_MENU.map((menu, idx) => {
          if (!menu?.show) {
            return null;
          }
          return (
            <NavLink
              key={idx}
              to={menu?.route}
              className={({ isActive }) =>
                isStart
                  ? isActive
                    ? "text-wce-navy-light"
                    : "text-white"
                  : isActive
                  ? "text-wce-pink-dark"
                  : "text-wce-neutral-8"
              }
            >
              <span className="">{menu?.label}</span>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

export default Menu;
